import { render, staticRenderFns } from "./electroniContract.vue?vue&type=template&id=32321091&"
import script from "./electroniContract.vue?vue&type=script&lang=js&"
export * from "./electroniContract.vue?vue&type=script&lang=js&"
import style0 from "./electroniContract.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports